import { LoanCalculationStepPage } from "../loan-calculation-step/loan-calculation-step.page";
import { PersonalDataStepPage } from "../personal-data-step/personal-data-step.page";
import { ChoiceOfficeStepPage } from "../choice-office-step/choice-office-step.page";
import { AccountConfirmationStepPage } from "../account-confirmation-step/account-confirmation-step.page";
import { SigningOfAgreementsStepPage } from "../signing-of-agreements-step/signing-of-agreements-step.page";
import { ConfirmationApplicationStepPage } from "../confirmation-application-step/confirmation-application-step.page";
import { ApplicationSendingStepPage } from "../application-sending-step/application-sending-step.page";
import { SelectAccountStepPage } from "../select-account-step/select-account-step.page";
import { SignFinalDocumentPackStepComponent } from "../sign-final-document-pack-step/sign-final-document-pack-step.component";
import { LoanWasHastilyIssuedStepPage } from "../loan-was-hastily-issued-step/loan-was-hastily-issued-step.page";

export enum Steps {
  calculation = 'loan-calculation',
  personalData = 'personal-data',
  choiceOffice = 'choice-office',
  accountConfirmation = 'account-confirmation',
  signAgreements = 'sign-agreements',
  applicationConfirmation = 'application-confirmation',
  applicationSending = 'application-sending',
  selectAccount = 'select-account',
  signFinalDocumentPack = 'sign-final-document-pack',
  loanWasIssued = 'loan-was-issued',
  confirmFinalRequest = 'confirm-final-request'
}

export interface Step {
  name: Steps;
  component: any;
  injectableData?: any;
}

export const STEPS_WITH_COMPONENTS: Step[] = [
  {
    name: Steps.calculation,
    component: LoanCalculationStepPage,
  },
  {
    name: Steps.personalData,
    component: PersonalDataStepPage
  },
  {
    name: Steps.choiceOffice,
    component: ChoiceOfficeStepPage
  },
  {
    name: Steps.accountConfirmation,
    component: AccountConfirmationStepPage
  },
  {
    name: Steps.signAgreements,
    component: SigningOfAgreementsStepPage
  },
  {
    name: Steps.applicationConfirmation,
    component: ConfirmationApplicationStepPage,
  },
  {
    name: Steps.applicationSending,
    component: ApplicationSendingStepPage
  },
  {
    name: Steps.selectAccount,
    component: SelectAccountStepPage
  },
  {
    name: Steps.signFinalDocumentPack,
    component: SignFinalDocumentPackStepComponent
  },
  {
    name: Steps.loanWasIssued,
    component: LoanWasHastilyIssuedStepPage
  },
  {
    name: Steps.confirmFinalRequest,
    component: ConfirmationApplicationStepPage,
  }
]
